import { Component, input } from '@angular/core';
import { CaseTrackerComponent } from '../case-tracker/case-tracker.component';
import { NgTemplateOutlet } from '@angular/common';
import { TrackerStepComponent } from '../tracker-step/tracker-step.component';
import { Message } from 'src/config/constants';
import { EntFormWidgetsModule } from '@ng/ent-components/ent-form-widgets';
import { EntTabsModule } from '@ng/ent-components/ent-tabs';
import { ContractData, ContractStatusTracker, Reg60StatusTracker } from 'src/app/shared/models/app.model';

@Component({
  selector: 'app-tracker-tabs',
  templateUrl: './tracker-tabs.component.html',
  imports: [CaseTrackerComponent, TrackerStepComponent, EntFormWidgetsModule, EntTabsModule, NgTemplateOutlet],
  styleUrls: ['./tracker-tabs.component.scss']
})
/**
 * Renders case-status and REG60 tracker views in tabbed layouts.
 */
export class TrackerTabsComponent {
  message = Message;

  /** Indicates that a letter of authorization is unavailable. */
  readonly noLOA = input<boolean>(false);

  /** Indicates that a letter of authorization is available. */
  readonly notNoLOA = input<boolean>(false);

  /** Ordered status steps for the contract case tracker. */
  readonly contractTrackerData = input<ContractStatusTracker[]>([]);

  /** Contract details used by tracker steps and navigation. */
  readonly contractData = input<ContractData | undefined>();

  /** Normalized REG60 tracker data, grouped by REG60 number. */
  readonly reg60TrackerData = input<Reg60StatusTracker[]>([]);

  /** Enables the tracker layout and labels intended for small screens. */
  readonly mobileView = input<boolean>(false);
}
